import { throttle } from 'lodash';
import { useLayoutEffect, useMemo, useState } from 'react';
import { system } from 'styled-system';
import { findMatchMedia } from './findMatchMedia';
import { useTheme } from '../useTheme';
export const useBreakpoint = () => {
    const theme = useTheme();
    const matchMedias = useMemo(() => {
        const breakpointsKeys = Object.keys(theme.breakpoints).filter((v) => Number.isNaN(Number.parseInt(v, 10)));
        const breakpointObj = {};
        for (const breakpointsKey of breakpointsKeys) {
            breakpointObj[breakpointsKey] = breakpointsKey;
        }
        const breakpointArr = system({
            breakpoint: true,
        })({
            breakpoint: breakpointObj,
            theme,
        });
        return Object.keys(breakpointArr).map((query) => ({
            breakpoint: breakpointArr[query].breakpoint,
            matchMedia: typeof window === 'undefined'
                ? null
                : window.matchMedia(query.replace('@media ', '')),
            query,
        }));
    }, [theme]);
    const [breakpoint, setBreakpoint] = useState(() => findMatchMedia(matchMedias));
    useLayoutEffect(() => {
        setBreakpoint(findMatchMedia(matchMedias));
        const calcInnerWidth = throttle(() => {
            setBreakpoint(findMatchMedia(matchMedias));
        }, 200);
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', calcInnerWidth);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', calcInnerWidth);
            }
        };
    }, [matchMedias]);
    return breakpoint;
};
//# sourceMappingURL=useBreakpoint.js.map